export const INFORMATIONS_COMPLEMENTAIRES_MOTIFS = {
  BRSA_INJOIGNABLE: "BRSA_INJOIGNABLE",
  BRSA_NSDD: "BRSA_NSDD",
  CHANGEMENT_ADRESSE_MUTATION_DEPART: "CHANGEMENT_ADRESSE_MUTATION_DEPART",
  CONTRACTUALISATION_EFFECTIVE: "CONTRACTUALISATION_EFFECTIVE",
  CONTROLE_SUR_PLACE_DEMANDE: "CONTROLE_SUR_PLACE_DEMANDE",
  DEMANDE_NOUVEAUX_DROITS_NON_CUMULABLES_RSA:
    "DEMANDE_NOUVEAUX_DROITS_NON_CUMULABLES_RSA",
  DEROGATION_RSA_ACCORDEE: "DEROGATION_RSA_ACCORDEE",
  DOSSIER_DROITS_SUSPENDUS: "DOSSIER_DROITS_SUSPENDUS",
  FIN_RSAM_INF_6_MOIS: "FIN_RSAM_INF_6_MOIS",
  INFORMATION_COMPLEMENTAIRE_RECUE: "INFORMATION_COMPLEMENTAIRE_RECUE",
  NOUVEAU_MATRICULE: "NOUVEAU_MATRICULE",
  PLI_AVISE_NON_RECLAME: "PLI_AVISE_NON_RECLAME",
  PLI_AVISE_RECLAME: "PLI_AVISE_RECLAME",
  PND: "PND",
  RADIATION_RSA: "RADIATION_RSA",
  TITRE_DE_SEJOUR_NON_VALIDE: "TITRE_DE_SEJOUR_NON_VALIDE",
};

export const INFORMATIONS_COMPLEMENTAIRES_LABELS = {
  [INFORMATIONS_COMPLEMENTAIRES_MOTIFS.BRSA_INJOIGNABLE]: "BRSA injoignable",
  [INFORMATIONS_COMPLEMENTAIRES_MOTIFS.BRSA_NSDD]: "BRSA NSDD",
  [INFORMATIONS_COMPLEMENTAIRES_MOTIFS.CHANGEMENT_ADRESSE_MUTATION_DEPART]:
    "Changement d'adresse / mutation / Départ",
  [INFORMATIONS_COMPLEMENTAIRES_MOTIFS.CONTRACTUALISATION_EFFECTIVE]:
    "Contractualisation effective",
  [INFORMATIONS_COMPLEMENTAIRES_MOTIFS.CONTROLE_SUR_PLACE_DEMANDE]:
    "Contrôle sur place demandé",
  [INFORMATIONS_COMPLEMENTAIRES_MOTIFS.DEMANDE_NOUVEAUX_DROITS_NON_CUMULABLES_RSA]:
    "Demande de nouveaux droits non cumulables avec le RSA en cours",
  [INFORMATIONS_COMPLEMENTAIRES_MOTIFS.DEROGATION_RSA_ACCORDEE]:
    "Dérogation RSA accordée",
  [INFORMATIONS_COMPLEMENTAIRES_MOTIFS.DOSSIER_DROITS_SUSPENDUS]:
    "Dossier/droits suspendus",
  [INFORMATIONS_COMPLEMENTAIRES_MOTIFS.FIN_RSAM_INF_6_MOIS]:
    "Fin de RSAM inférieure à 6 mois",
  [INFORMATIONS_COMPLEMENTAIRES_MOTIFS.INFORMATION_COMPLEMENTAIRE_RECUE]:
    "Information complémentaire reçue",
  [INFORMATIONS_COMPLEMENTAIRES_MOTIFS.NOUVEAU_MATRICULE]: "Nouveau matricule",
  [INFORMATIONS_COMPLEMENTAIRES_MOTIFS.PLI_AVISE_NON_RECLAME]:
    "PLI avisé non réclamé",
  [INFORMATIONS_COMPLEMENTAIRES_MOTIFS.PLI_AVISE_RECLAME]: "Pli avisé réclamé",
  [INFORMATIONS_COMPLEMENTAIRES_MOTIFS.PND]: "PND",
  [INFORMATIONS_COMPLEMENTAIRES_MOTIFS.RADIATION_RSA]: "Radiation du RSA",
  [INFORMATIONS_COMPLEMENTAIRES_MOTIFS.TITRE_DE_SEJOUR_NON_VALIDE]:
    "Titre de séjour non valide",
};
